import React from 'react'

import { connect } from 'react-redux'

import {
    Row,
    Modal,
    Checkbox,
    Col,
    Input,
    message
} from 'antd'

import { ADMIN_URL } from '../../../index'

import { routes } from '../../../routes'

import {
    setPermission,
} from '../actions'
import { Router } from 'react-router-dom'


class PermissionsModal extends React.Component {

    
    render(){

        const { title, pages } = this.state

        return(
            <Modal
                okButtonProps={{
                    disabled: title.length == 0 || pages.length == 0
                }}
                onOk={this.handleOk}
                closable={false}
                centered
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                afterClose={this.props.afterClose}
            >
                <Row>
                    <h3>
                    Permission Name
                    </h3>
                </Row>
                <Row style={{marginBottom: 12}}>
                    <Input
                        value={title}
                        onChange={e => this.setState({ title: e.target.value })}
                        placeholder="Permission name"
                    />
                </Row>
                <div>
                    <Row type="flex" align="middle">
                        <h3>
                        Pages
                        </h3>
                        <Checkbox
                        style={{marginLeft: 16}}
                        onChange={this.handleToggleAll}
                        >Select All</Checkbox>
                    </Row>
                    {/* <Row style={{marginBottom: 12}}>
                        <Col>
                            <Input
                                onChange={e => this.setState({ activePageInput: e.target.value })}
                                value={this.state.activePageInput}
                                onPressEnter={this.handleAddPage}
                                placeholder="Pathname e.g. data-reports"
                                />
                        </Col>
                    </Row> */}
                    <div style={{maxHeight: 600, overflowY: 'scroll'}}>
                        {this.getRootRoutes()
                            .map( _route => {
                        
                                const kebabName = _route.path.split('/')[1]
                                
                                return (
                                    <Row style={{margin: '4px 0px'}}>
                                            <Checkbox
                                                onChange={(e)=>this.handleTogglePage({kebabName, checked: e.target.checked})}
                                                checked={this.getPageChecked(kebabName)}
                                                style={{marginLeft: 12}}>
                                                    {_route.path}
                                            </Checkbox>
                                    </Row>
                                )
                            })}
                    </div>
                </div>
            </Modal>
        )
    }

    constructor(props){
        super(props)

        const { activePermission } = props

        this.state = {
            title: activePermission.title? activePermission.title : '',
            pages: activePermission.pages? activePermission.pages : [],
            // activePageInput: ''
        }
    }

    // handleAddPage = (e) => {
    //     this.setState({
    //         activePageInput: '',
    //         pages: [...this.state.pages, {
    //             kebabName: e.target.value
    //         }]
    //     })
    // }
    
    getPageChecked = (kebabName) => {

        const { pages } = this.state

        let isChecked = false

        pages.map( _page => {
            if( _page.kebabName == kebabName ){
                isChecked = true
            }
        })

        return isChecked

    }

    getRootRoutes = () => {

        let rootRoutes = {}

        routes.map( _route => {
            const rootPath = '/' + _route.path.split('/')[1]

            if( !rootRoutes[rootPath] ){
                rootRoutes[rootPath] = {
                    path: rootPath
                }
            }
        })

        return Object.values(rootRoutes)

    }

    handleToggleAll = (e) => {

        const { checked } = e.target

        if ( checked ){
            this.setState({
                pages: this.getRootRoutes().map( _route => ({kebabName: _route.path.split('/')[1]}))
            })
        } else {
            this.setState({
                pages: []
            })
        }

    }

    handleTogglePage = ({kebabName, checked}) => {

        if( checked ){
            
            this.setState({
                pages: [...this.state.pages, {
                    kebabName
                }]
            })
                
        } else {

            this.setState({
                pages: this.state.pages.filter( _page => _page.kebabName != kebabName )
            })

        }

    }

    handleOk = () => {

        const { title, pages } = this.state

        if( title.length == 0 ){
            return message.error("Permission name is required!")
        }

        if( pages.length == 0 ){
            return message.error("At least one page is required!")
        }

        this.props.setPermission({
            permissionId: this.props.activePermission._id,
            title,
            pages
        })

        this.props.onCancel()
        
    }
}

export default connect(
    state => ({
        permissions: state.admins.permissions,
        activePermission: state.admins.activePermission
    }),
    dispatchEvent => ({
        setPermission: ( permission ) => dispatchEvent( setPermission( permission ) ),
    })
)(PermissionsModal)


// WEBPACK FOOTER //
// ./src/components/admin/permissions/modal.js